const LOCO_URL = "https://cdn.dev.envs.lookiero.tech/i18n";
const translationEndpoints = ({ projects, tradename }) => (locale) => projects.map((project) => `${LOCO_URL}/${tradename.toLowerCase()}/${project}/${locale}.json`);
export { translationEndpoints };
